import http from '@/utils/http';

/**
 * 获取分页查询客户交接-cyj
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customer/page',
        method: 'post',
        data
    });
};

/**
 * 批量修改客户承接人-cyj
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customer/batchSave',
        method: 'post',
        data
    });
};

/**
 * 单个修改客户承接人-cyj
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customer/save',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customer/importCustomer',
        method: 'post',
        data
    });
};
